import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	anonymous: {
		id: 'servicedesk-customer-service-issue-view-panel.customer.customer-field.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Text for when the customers or organizations field has no value',
	},
});
